import React from 'react'
import ErrorMessage from './errorMessage'
import { useUserContext } from '../contexts/userContext';
import Json from './json';

export interface IPermissionGateProps {
  permission: boolean | undefined,
  children: React.ReactNode
}

const PermissionGate: React.FunctionComponent<IPermissionGateProps> = ({ permission, children }) => {
	const userContext = useUserContext();
	
	return (
	<div className="hwi-permissiongate">
		{permission ? (children) : (
			<ErrorMessage>
				<p>You do not have permission to access this screen. </p>
				<p>Please contact your system administrator.</p>
			</ErrorMessage>
		)}
		{/* <Json data={userContext.permissions}></Json> */}
	</div>
  )
}

export default PermissionGate;